// Typed access to window.HomeLabTheme (wwwroot/js/theme.js, loaded in <head> before first paint).
export type ThemeChoice = 'system' | 'light' | 'dark';

interface ThemeApi {
  get(): ThemeChoice;
  set(choice: ThemeChoice): void;
}

declare global {
  interface Window {
    HomeLabTheme?: ThemeApi;
  }
}

export function getTheme(): ThemeChoice {
  return window.HomeLabTheme?.get() ?? 'system';
}

export function setTheme(choice: ThemeChoice): void {
  window.HomeLabTheme?.set(choice);
}

/** Wires the System / Light / Dark buttons (`[data-theme-choice]`) in the user menu. */
export function bindThemePicker(root: ParentNode = document): void {
  const buttons = [...root.querySelectorAll<HTMLButtonElement>('[data-theme-choice]')];
  if (buttons.length === 0) return;

  const sync = () => {
    const current = getTheme();
    for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.themeChoice === current));
  };

  for (const button of buttons) {
    button.addEventListener('click', () => {
      setTheme(button.dataset.themeChoice as ThemeChoice);
      sync();
    });
  }
  sync();
}
